import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';

interface PermissionRouteProps {
    children: ReactNode;
    permission: string; // Admin submenu name, e.g. "User Management"
}

/** Returns true if the role's menu_list grants the given Admin submenu permission. */
export const hasPermission = (roleMenuList: any[] | undefined, permission: string): boolean => {
    const adminGroup = (roleMenuList || []).find((g: any) => g.menu === 'Admin');
    if (!adminGroup) return false;
    const submenus = adminGroup.submenus || [];
    if (submenus.some((s: any) => (typeof s === 'string' ? s : s.name) === permission)) {
        return true;
    }
    // Backward compatibility for Tracking Card Order: allow any Admin role to access it
    if (permission === 'Tracking Card Order') {
        return submenus.length > 0;
    }
    return false;
};

const PermissionRoute = ({ children, permission }: PermissionRouteProps) => {
    const location = useLocation();
    const { isAuthenticated, user } = useSelector((state: RootState) => state.Auth);

    // Not logged in → send to login
    if (!isAuthenticated) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // Logged in but role doesn't grant this permission → send to portal home
    if (!hasPermission(user?.roleMenuList as any[], permission)) {
        return <Navigate to="/welcome" replace />;
    }

    return <>{children}</>;
};

export default PermissionRoute;
